import { EyeIcon, EyeOffIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui';

type Props = {
  /** Блок показан целиком; повторное нажатие возвращает его к отобранному виду */
  isShownFull: boolean;
  onToggle: () => void;
};

/**
 * Переключатель полного показа блока заключения: раскрывает скрытое отбором содержимое одного блока,
 * не трогая сам отбор и остальные блоки.
 */
export const EvaluationBlockFullViewButton: FC<Props> = ({ isShownFull, onToggle }) => {
  const { t } = useTranslation(['dialogs']);
  const label = isShownFull ? t('dialogs:expertReport.showFilteredBlock') : t('dialogs:expertReport.showFullBlock');

  return (
    <IconButton
      size="icon"
      className="size-5 shrink-0"
      label={label}
      aria-pressed={isShownFull}
      icon={isShownFull ? <EyeOffIcon className="size-3" /> : <EyeIcon className="size-3" />}
      onClick={onToggle}
    />
  );
};
